/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import withCustomComponent from "ui/components/withCustomComponent";
import { useTeamDiscount } from '@bw-ui/hooks/useTeamDiscount';

const BookingDiscountFormBW = withCustomComponent('BookingDiscountFormBW')(
  inject(
    'appStore',
    'authStore',
    'bookingsStore'
  )(
    observer(({ bookingsStore, componentName, withBorder, updateBooking, authStore }) => {
      const { t } = useTranslation();

      const { booking, bookingPrice } = bookingsStore;
      const { teamDiscounts } = useTeamDiscount();

      if (!booking.ResourceId) return <></>;

      if (!authStore.me) {
        return <></>;
      }

      return (
        <div
          data-component-name={componentName}
          className="mt-24 booking-discount-form"
        >
          <h6 className="mb-8">{t('Discount code')}</h6>
          <div
            className={`d-flex align-items-center justify-content-between bg-white ${
              withBorder && 'border'
            } rounded p-8 fs-14 mb-12`}
          >
            <input
              id="BookingDiscountFormInputField"
              className="w-100 border-0 outline-0"
              defaultValue={booking.DiscountCode}
              placeholder={t('Enter discount code')}
            />
            <button
              className="btn btn-xs btn-gray"
              onClick={(e) => {
                e.preventDefault();
                updateBooking(
                  'DiscountCode',
                  document.getElementById('BookingDiscountFormInputField').value
                );
              }}
            >
              {t('Apply')}
            </button>
          </div>
          {bookingPrice && bookingPrice.discountCode && (
            <div>
              {bookingPrice.discountCode.discountMessage && (
                <div className="text-red fs-14 mb-12">
                  {bookingPrice.discountCode.discountMessage}
                </div>
              )}
              {bookingPrice.discountCode.description && (
                <div className="text-green fs-14 mb-12">
                  {bookingPrice.discountCode.description}
                </div>
              )}
              {teamDiscounts.bookings > 0 && (
                <div className="text-green fs-14 mb-12">
                  {t(`${teamDiscounts.bookings}% Bruntwood Discount applied`)}
                </div>
              )}
            </div>
          )}
        </div>
      );
    })
  )
);

export default BookingDiscountFormBW;
